import { constants } from "@newsela/angelou";

const uiColors = constants.colors.ui;

export const deleteOverlayContainer = {
  display: "flex",
  alignItems: "center",
  marginLeft: "0",

  "div:first-of-type": {
    marginRight: "8px",
  },
};

export const neverMindButtonCss = {
  "&:hover": {
    backgroundColor: uiColors.neutral[50],
  },
};
